import { lazy, LazyExoticComponent, ComponentType } from 'react';

/**
 * Wraps React.lazy() to reload the page when a chunk fails to load.
 * Handles "version skew": after a deploy, old chunk URLs (404) cause
 * "Failed to fetch dynamically imported module". A full reload fetches
 * fresh index.html and correct chunks.
 */
export function lazyWithReloadOnError<T extends ComponentType<object>>(
  importFn: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (e) {
      // Chunk 404 — likely new deploy. Reload to get fresh build.
      window.location.reload();
      throw e; // Satisfies types; page will reload
    }
  });
}
